import { formatHtml } from "@trumpf/ux.common-storybook";
import { getIframePageDecorators } from "../../../shared/page";
import { HotspotTemplate } from "./hot-spot.templates";

export default {
    title: "Website/Partial Templates/Hotspot",
    render: HotspotTemplate.bind({}),
    tags: ["autodocs"],
    decorators: getIframePageDecorators(),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
        layout: "fullscreen",
    },
};

/**
 * For details on the HotSpot and HotSpotNav components, see the HotSpot / HotSpotNav documentation.
 */
export const Hotspot = {};
